<template>
  <div class="c-aed-report">
    <div
      class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border"
    >
      {{ translationsReport.sectionName }}
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsReport.idLabel || ''">{{
            translationsReport.idLabel || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <span class="o-grid__item--text">
            {{ id || "" }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsReport.address || ''">{{
            translationsReport.address || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <span class="o-grid__item--text">
            {{ address || "" }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsReport.access || ''">{{
            translationsReport.access || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <span class="o-grid__item--text">
            {{ accessConditions || "" }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span
            class="o-label"
            :title="translationsReport.organisation || ''"
            >{{ translationsReport.organisation || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--7">
          <span class="o-grid__item--text">
            {{ organizationCompany || "" }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsReport.description || ''">{{
            translationsReport.description || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <span class="o-grid__item--text">
            {{ reportDescription || "" }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12 o-grid__item--margin-top">
          <span class="o-label" :title="translationsReport.comment || ''">{{
            translationsReport.comment || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--12">
          <CallCenterAEDeditableTextArea
            section="comment"
            name="comment"
            storeModule="tip"
            :initialValue="comment || ''"
          ></CallCenterAEDeditableTextArea>
        </div>
      </div>
    </div>
    <div v-if="isKnown">
      <div
        class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border o-heading--margin-top"
      >
        {{ translationsReport.defibrillatorSection }}
      </div>
      <div
        class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
      >
        <div class="o-grid__group">
          <div class="o-grid__item o-grid__item--5">
            <span class="o-label" :title="translationsReport.idLabel || ''">{{
              translationsReport.idLabel || ""
            }}</span>
          </div>
          <div class="o-grid__item o-grid__item--7">
            <span class="o-grid__item--text">
              {{ baseDefibrillator || "" }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
      >
        <div class="o-grid__group">
          <div class="o-grid__item o-grid__item--5">
            <span class="o-label" :title="translationsReport.fadder || ''">{{
              translationsReport.fadder || ""
            }}</span>
          </div>
          <div class="o-grid__item o-grid__item--7">
            <span class="o-grid__item--text">
              {{ fadder || "" }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
      >
        <div class="o-grid__group">
          <div class="o-grid__item o-grid__item--5">
            <span v-if="baseDefibrillator">
              <router-link
                :to="{
                  name: 'Home',
                  query: { aed: baseDefibrillator }
                }"
                class="o-link"
                target="_blank"
                >{{ translationsCustom.seeDefibrillator || "" }}</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-aed-report",
  data() {
    return {
      section: "address",
      name: "Report",
      mutableAddress: {},
      mutableLocation: {},
      selectedCategory: {},
      selectedLocality: {},
      editingLocality: false,
      editingAddress: false,
      showAddressUpdateMessage: false,
      showLocationUpdateMessage: false
    };
  },
  computed: {
    ...mapGetters("tip", [
      "parameters",
      "id",
      "address",
      "reportDescription",
      "accessConditions",
      "organizationCompany",
      "placement",
      "baseDefibrillator",
      "fadder",
      "isKnown",
      "comment"
    ]),
    ...mapState("tips", ["addressCategories"]),
    ...mapState("tip", ["loading"]),
    ...mapState("translations", {
      translationsReport: "report",
      translationsCustom: "custom"
    }),
    google: gmapApi,
    selectableLocalities() {
      return this.selectedCategory.id !== 0 ? this.selectedCategory.types : [];
    }
  },
  methods: {
    updateCoordinates() {
      this.getCoordinatesFromAddressDataApi();
      this.editingAddress = false;
      this.showLocationUpdateMessage = false;
    },
    getCoordinatesFromAddressDataApi() {
      var url =
        this.$dawaUrl +
        "api/adresser?vejnavn=" +
        this.mutableAddress.street +
        "&husnr=" +
        this.mutableAddress.number.replace(
          /^[^0-9]*([0-9]+)\s*([a-zA-Z]?).*/g,
          "$1$2"
        ) +
        "&postnr=" +
        this.mutableAddress.postalCode;
      this.isApiResponsesuccessful = false;
      var request = new XMLHttpRequest();
      request.open("GET", url, false);
      request.onload = () => {
        var results = JSON.parse(request.response);
        if (request.status >= 200 && request.status < 400) {
          if (results[0]) {
            if (results[0].adgangsadresse.adgangspunkt.koordinater.length > 0) {
              this.mutableLocation.longitude =
                results[0].adgangsadresse.adgangspunkt.koordinater[0];
              this.mutableLocation.latitude =
                results[0].adgangsadresse.adgangspunkt.koordinater[1];
            } else {
              this.mutableLocation.longitude =
                results[0].adgangsadresse.vejpunkt.koordinater[0];
              this.mutableLocation.latitude =
                results[0].adgangsadresse.vejpunkt.koordinater[1];
            }
            this.mutableAddress.MunicipalityId =
              results[0].adgangsadresse.kommune.kode;
            this.updateCoordinatesFromApi();
          } else {
            window.alert("No results found"); //TODO
          }
        } else {
          window.alert("Request failed"); //TODO
        }
      };
      request.send();
    },
    updateCoordinatesFromApi() {
      this.submitCoordinates();
      this.submitAddress();
      this.showAddressUpdateMessage = true;
    },
    submitCoordinates() {
      let payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: "placement",
        method: "PATCH",
        data: this.mutableLocation
      };
      // payload.data[this.name] = this.mutableValue;

      this.$store.dispatch("aed/setSection", payload);
    },
    submitAddress() {
      let payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        method: "PATCH",
        data: this.mutableAddress
      };
      // payload.data[this.name] = this.mutableValue;

      this.$store.dispatch("aed/setSection", payload);
    },
    setSelectedCategory(value) {
      this.selectedCategory = value;
      this.editingLocality = true;
      this.canCancelLocalityEdit = false;
      this.selectedLocality = [];
    },
    // setInitialCategory() {
    //   this.selectedCategory =
    //     this.addressCategories.find(
    //       category => category.id === this.address.categoryId
    //     ) || this.address.category;
    //   this.selectedLocality = this.selectedCategory
    //     ? this.selectedCategory.types.find(
    //         locality => locality.id === this.address.localityId
    //       ) || this.address.locality
    //     : this.address.locality;
    // },
    // resetCategory() {
    //   this.setInitialCategory();
    //   this.editingLocality = false;
    // },
    resetAddress() {
      this.mutableAddress = {
        street: this.address.street,
        number: this.address.number,
        floor: this.address.floor,
        postalCode: this.address.postalCode,
        city: this.address.city
      };
      this.editingAddress = false;
    },
    resetAddressCoordinates() {
      this.submitCoordinates();
      this.showLocationUpdateMessage = false;
    }
  },
  created() {
    //this.setInitialCategory();
    this.mutableAddress = {
      street: this.address.street,
      number: this.address.number,
      floor: this.address.floor,
      postalCode: this.address.postalCode,
      city: this.address.city
    };
    // this.mutableLocation = {
    //   latitude: this.placement.latitude,
    //   longitude: this.placement.longitude
    // };
  },
  watch: {
    placement: {
      // handler: function(newValue) {
      //   const changedLatitude =
      //     this.mutableLocation.latitude !== newValue.latitude;
      //   const changedLongitude =
      //     this.mutableLocation.longitude !== newValue.longitude;
      //   this.showLocationUpdateMessage = changedLatitude || changedLongitude;
      // },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.c-aed-address {
  &__notication {
    background-color: $s-cp-neutral-800;
    padding: toRem(20px 20px 30px);
    @include setStyles("14", $s-typography-sizes);
  }
  &__notication-text {
    @include setStyles("14", $s-typography-sizes);
    color: $s-cp-neutral-300;
  }
  &__notication-button {
    color: $s-cp-sup-blue;
    font-weight: 700;
  }
}
</style>
